const SmsState = {
  notProcessed: 0,
  processing: 1,
  canceled: 2,
  unsubscribed: 3,
  processed: 4,
  later: 5,
  blocked: 6,
};

export default SmsState;
